var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 3.99999V10.4C14.4001 10.8243 14.2315 11.2313 13.9315 11.5314C13.6314 11.8314 13.2244 12 12.8001 12H8.8001L4.8001 15.2V12H3.2001C2.77575 12 2.36878 11.8314 2.06873 11.5314C1.76867 11.2313 1.6001 10.8243 1.6001 10.4V3.99999C1.6001 3.57565 1.76867 3.16868 2.06873 2.86862C2.36878 2.56856 2.77575 2.39999 3.2001 2.39999H12.8001C13.2244 2.39999 13.6314 2.56856 13.9315 2.86862C14.2315 3.16868 14.4001 3.57565 14.4001 3.99999ZM5.6001 6.39999H4.0001V7.99999H5.6001V6.39999ZM7.2001 6.39999H8.8001V7.99999H7.2001V6.39999ZM12.0001 6.39999H10.4001V7.99999H12.0001V6.39999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt);
export default __webpack_public_path__ + "static/media/ChatAlt.82488aeaf52be3b66c0884ff7a48c8be.svg";
export { ForwardRef as ReactComponent };